module.exports = __webpack_public_path__ + "static/img/假牙.79b2520.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/假牙.jpg
// module id = zSSu
// module chunks = 7